import { WidgetsWarehouseFormMain } from '@/widgets/warehouse-form';

export const PagesWarehouseCreateMain = () => <WidgetsWarehouseFormMain mode="create" />;
